import axios from 'axios'
import React, { useContext, useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import Slider from 'react-slick';
import { toast } from 'react-toastify';
import { Cartcontext } from '../Cartcontext';
import { WishlistContext } from '../WishContext';

function ProductDetails() {
  const {cart ,setcart} = useContext(Cartcontext)
  const { addToWishlist, removeFromWishlist ,isInWishlist } = useContext(WishlistContext);

  async function  AddProductToCart(productId){
    const {data} = await axios.post('https://ecommerce.routemisr.com/api/v1/cart?' ,{productId :productId} , {headers :{token:localStorage.getItem('token')}})
    toast.success("successfuly added ⭐ ​", {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
      });
  setcart(data)
    console.log(data)
  }

  async function  AddProductTowishlist(productId){
    const {data} = await axios.post('https://ecommerce.routemisr.com/api/v1/wishlist?' ,{productId :productId} , {headers :{token:localStorage.getItem('token')}})
    toast("successfuly added to wish list ❤️​", {
      position: "top-right",
      autoClose: 1000,
      hideProgressBar: true,
      closeOnClick: false,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",

  });
    console.log(data)
  }
  async function RemoveProductWish(productId) {
    await axios.delete('https://ecommerce.routemisr.com/api/v1/wishlist/' + productId, { headers: { token: localStorage.getItem('token') } })
}
  const settings = {
    dots: true,
    fade: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    waitForAnimate: false
  };
    const[Isloading , setIsloading]= useState(false)
    const[imges , setimages]= useState([])


    const {id} = useParams()
   const[productDetails , setproductDetails]= useState({})
  async function getProductsDetails(){
    setIsloading(true)
    let {data} = await axios.get('https://ecommerce.routemisr.com/api/v1/products/'+id)
    setIsloading(false)

    setproductDetails(data.data)
    // console.log(data.data.images)
    setimages(data.data.images)
   }
   useEffect(()=>{
    getProductsDetails()
},[])
   return (

        <>
            <div className="container pt-5 mt-5">
            { Isloading ?<>
                <div className='d-flex align-items-center justify-content-center my-5 py-5'>
                    <i className='fas fa-spin fa-spinner fa-2x'></i>
                </div>
            </>:
            <div className='row align-items-center py-5' >
            <div className="col-md-3">


              <Slider {...settings}>
                {imges?.map((image ,index) =>{
                 return <div key={index}><img src={ image} className='w-100'/> </div>
                })}

             </Slider>

            </div>
            <div className="col-md-9">
                <h2 className='mt-2'>{productDetails?.title}</h2>
                <h5 className='font-sm text-main mt-2'>{productDetails?.category?.name}</h5>
                <p className='mt-2'>{productDetails?.description}</p>
             <i   onClick={() => {
          if (isInWishlist(productDetails.id)) {
            RemoveProductWish(productDetails.id);
            removeFromWishlist(productDetails.id)
          } else {
            AddProductTowishlist(productDetails.id);
            addToWishlist(productDetails)
          }
        }}
        className={`fa-solid fa-heart h3 ${
          isInWishlist(productDetails.id) ? 'text-danger' : ''
        }`}
      ></i>

                <p className='d-flex justify-content-between mt-2'>
                    <span>{productDetails?.price} EGP</span>
                    <span>
                        <i className='fas fa-star rating-color me-1'></i>
                        <span>{productDetails?.ratingsAverage}</span>
                    </span>
                </p>
                <button className='btn bg-main text-white w-100 mt-2' onClick={()=>{AddProductToCart(productDetails.id)}}>Add To Cart</button>

            </div>

        </div>
    }
            </div>
            
           

</>

    )
}

export default ProductDetails